import { NavLink, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import CastleLogo from '../../assets/images/Logo_Castle.png';
import {
  faQuestion,
  faMessage,
  faCircle,
  faChalkboardUser,
  faFolderOpen,
  faPlay,
  faPhone,
  faEnvelope,
  faUser,
  faIdBadge,
  faGraduationCap,
  faUserGear,
  faRightFromBracket,
  faBell
} from '@fortawesome/free-solid-svg-icons';
import {
  faSendBackward,
  faMessagesQuestion,
  faTableLayout,
  faBarsSort
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'font-awesome/css/font-awesome.min.css';
import {
  globalLogout,
  selectCurrentUserData,
  selectSelectedAssignmentId,
  setCurrentCenter,
  selectCurrentCenter,
} from '../../features/authentication/authSlice';
import { useNavigateToClassicCastleMutation, useUpdateViewStatusBulkMutation } from '../../features/authentication/authApiSlice';
import {
  OverlayTrigger,
  Tooltip,
  Nav,
  Navbar,
  NavDropdown,
  Button,
  Container
} from 'react-bootstrap';
import { SidebarData } from '../Layout/SidebarData';
import { useNavigate } from 'react-router-dom';
import HelpRequest from '../../pages/dashboard/components/Modals/HelpRequest';
import {
  useGetUserIdMutation,
  useSetUserIdStatusMutation
} from '../../features/authentication/dashboardHeaderApiSlice';
import './index.css';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import logoutImg from '../../assets/images/logout.png';
import Modal from '../Modal/index';
import { useLogoutMutation, useInitiateSiteSwitchLogMutation } from '../../features/authentication/authApiSlice';
import PropTypes from 'prop-types';
import ClickOutsideDetector from '../ClickOutsideDetector';
import UserTypes from '../../enums/userTypes';
import { CenterTypes, DEFAULT_CENTER_ID, getCenterById } from '../../enums/centerTypes';
import CustomToast from '../Toast';
import ReactGA from 'react-ga4';
import appConfig from '../../app-config';
import { useCheckBackToBlueprintEnabledMutation } from '../../features/authentication/rookBlueprintApiSlice';
import { useUpdateDefaultLandingPageMutation } from '../../features/authentication/studentApiSlice';
import { useGlobalContext } from '../../globalContext';
import Notification from '../Notification/notifications';
import NotificationToast from '../Notification/notificationToast';
import { toast } from 'react-toastify';

export default function Navigation() {
  const user = useSelector(selectCurrentUserData);
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [helpMenuVisible, setHelpMenuVisible] = useState(false);
  const [mainMenuVisible, setMainMenuVisible] = useState(false);
  const [helpRequestVisible, setHelpRequestVisible] = useState(false);
  const [userIdVisible, setUserIdVisible] = useState(false);
  const [userIdResponse, setUserIdReponse] = useState();
  const [userId, setUserId] = useState('Show User ID');
  const [getUserId] = useGetUserIdMutation();
  const [setUserIdStatus] = useSetUserIdStatusMutation();
  const [checked, setChecked] = useState(false);
  const [helpMenuName, setHelpMenuName] = useState('helpmenulist');
  const [mainMenuName, setMainMenuName] = useState('mainmenulist');
  const [notificationMenuVisible, setNotificationMenuVisible] = useState(false);
  const [notificationMenuName, setNotificationMenuName] = useState('');
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [logout] = useLogoutMutation();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [navToClassic, navToClassicResults] = useNavigateToClassicCastleMutation();
  const selectedAssignmentId = useSelector(selectSelectedAssignmentId);
  const [showFeedbackRequestModal, setShowFeedbackRequestModal] = useState(false);
  const [redirectModal, setRedirectModal] = useState(false);
  const [classicRedirectUrl, setClassicRedirectUrl] = useState(null);
  const [helpFeedbackModalType, setHelpFeedbackModalType] = useState(null);
  const [showConfirmClassicNavModal, setShowConfirmClassicNavModal] = useState(false);
  const [outsideClick, setOutsideClick] = useState(false);
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [initialiseSiteSwitchLog] = useInitiateSiteSwitchLogMutation();
  const [isSchoolMethodized, setIsSchoolMethodized] = useState(false);
  const [updateDefaultLoginSite] = useUpdateDefaultLandingPageMutation();
  const [checkBackToBlueprintEnabled] = useCheckBackToBlueprintEnabledMutation();
  const [centerToRestoreOnCancel, setCenterToRestoreOnCancel] = useState(null);
  const currentCenter = useSelector(selectCurrentCenter);
  const context = useGlobalContext();
  const [markAllAsRead] = useUpdateViewStatusBulkMutation();
  const [isClassicSwitchFeedback, setIsClassicSwitchFeedback] = useState(false);
  if (process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'testing')
    ReactGA.initialize(appConfig.googleAnalyticsKey);

  const switchableUserTypes = [
    UserTypes.SuperAdministrator,
    UserTypes.Administrator,
    UserTypes.Teacher,
    UserTypes.Sales,
    UserTypes.SuperSales,
    UserTypes.Trainer
  ];
  
  useEffect(() => {
    sendGoogleAnalytics();
  }, []);

  const sendGoogleAnalytics = () => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
    });
  };

  const mainMenuNav = [
    {
      id: 'classicSwitch',
      title: 'Switch to Classic Version',
      tag: 'a',
      path: '_blank',
      icon: faTableLayout,
      onClick: (e) => handleSwitchtoClassic(e),
      comingSoon: false
    },
    {
      id: 'myProfile',
      title: 'My Profile',
      tag: 'link',
      path: '/dashboard/Profile',
      icon: faUser,
      onClick: (e) => handleProfileClick(e),
      comingSoon: false
    },
    {
      id: 'userId',
      title: userId,
      tag: 'div',
      path: null,
      icon: faIdBadge,
      onClick: (e) => handleUserId(e),
      comingSoon: false
    },
    {
      id: 'logOut',
      title: 'LogOut',
      tag: 'a',
      path: '#',
      icon: faRightFromBracket,
      onClick: () => setShowLogoutModal(true),
      comingSoon: false
    }
  ];

  const helpMenuNav = [
    {
      id: 'teacherGuide',
      title: 'Getting Started',
      tag: 'a',
      path: 'https://hes-nextcloud.harriscomputer.io/index.php/s/z3D3bSycPmLsN5R',
      icon: faChalkboardUser,
      onClick: null
    },
    {
      id: 'helpResources',
      title: 'Help Resources',
      tag: 'a',
      path: 'https://www.castlelearning.com/help-resource-documents-for-teachers/',
      icon: faFolderOpen,
      onClick: null
    },
    {
      id: 'videoTutorials',
      title: 'Video Tutorials',
      tag: 'a',
      path: 'https://www.castlelearning.com/video-tutorials/',
      icon: faPlay,
      onClick: null
    },
    {
      id: 'helpRequest',
      title: 'Help Request',
      tag: 'div',
      path: null,
      icon: faMessagesQuestion,
      onClick: () => handleHelpRequest()
    },
    {
      id: 'telephone',
      title: '1-800-345-7606',
      tag: 'a',
      path: 'tel:1-800-345-7606',
      icon: faPhone,
      onClick: null
    },
    {
      id: 'email',
      title: 'support@castlelearning.com',
      tag: 'a',
      path: 'mailto:support@castlelearning.com',
      icon: faEnvelope,
      onClick: null
    }
  ];

  useEffect(() => {
    const refreshNotifications = async () => {
      context.getMessageCountAsync();
      const alerts = await context.getRecentAlertsAsync();
      showRecentAlertToasts(alerts);
    };
 
    refreshNotifications();
    const intervalId = setInterval(refreshNotifications, 60_000);
    return () => clearInterval(intervalId);
  }, []);
    
  useEffect(() => {
    getUserIdAsync();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    updateUserId();
    // eslint-disable-next-line
  }, [userIdResponse]);

  useEffect(() => {
    updateUserId();
    setUserIdStatusAsync([]);
    // eslint-disable-next-line
  }, [userIdVisible]);

  useEffect(() => {
    if (mainMenuVisible && !helpMenuVisible) {
      setMainMenuName('mainmenulist fadeOut');
    }

    if (helpMenuName == 'helpmenulist slideUp') {
      const timeout = setTimeout(() => {
        setHelpMenuVisible(false);
      }, 550);

      return () => {
        clearTimeout(timeout);
      };
    } else if (helpMenuName == 'helpmenulist slideDown') setHelpMenuVisible(true);
    // eslint-disable-next-line
  }, [helpMenuName]);

  useEffect(() => {
    if (helpMenuVisible && !mainMenuVisible) {
      setHelpMenuName('helpmenulist slideUp');
    }

    if (mainMenuName == 'mainmenulist fadeOut') {
      const timeout = setTimeout(() => {
        setMainMenuVisible(false);
      }, 350);

      return () => {
        clearTimeout(timeout);
      };
    } else if (mainMenuName == 'mainmenulist fadeIn') setMainMenuVisible(true);
    // eslint-disable-next-line
  }, [mainMenuName]);

  useEffect(() => {
    if (notificationMenuName === 'slideUp') {
      const timeout = setTimeout(() => {
        setNotificationMenuVisible(false);
      }, 500);
      return () => clearTimeout(timeout);
    }
    if (notificationMenuName === 'slideDown') {
      setNotificationMenuVisible(true);
    }
  }, [notificationMenuName]);

  useEffect(() => {
    if (redirectModal && classicRedirectUrl)
      setTimeout(() => {
        setRedirectModal(false);
        window.location.href = classicRedirectUrl;
      }, 5000);
    // eslint-disable-next-line
  }, [redirectModal]);

  useEffect(() => {
    if (outsideClick && helpMenuVisible) {
      setHelpMenuName('helpmenulist slideUp');
    } else if (outsideClick && notificationMenuVisible) {
      setNotificationMenuName('slideUp');
    } else if (outsideClick && mainMenuVisible) {
      setMainMenuName('mainmenulist fadeOut');
    }
    setOutsideClick(false);
    // eslint-disable-next-line
  }, [outsideClick]);

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${appConfig.zenDeskKey}`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const onZendeskLoaded = () => {
    if (typeof window.zE !== 'undefined') {
      window.zE(function () {
        window.zE('webWidget', 'hide');
        window.zE('webWidget:on', 'chat:connected', function () {
          const department = window.zE('webWidget:get', 'chat:department', 'Castle Learning');

          if (department && department.status === 'online') {
            window.zE('webWidget', 'show');
          } else {
            window.zE('webWidget', 'hide');
          }
        });
      });
    }
  };

  useEffect(() => {
    const zendeskScriptCheck = setInterval(() => {
      if (typeof zE !== 'undefined') {
        clearInterval(zendeskScriptCheck);
        onZendeskLoaded();
      }
    }, 500);

    return () => clearInterval(zendeskScriptCheck);
  }, []);

  const toggleHelpMenu = () => {
    if (helpMenuVisible) {
      setHelpMenuName('helpmenulist slideUp');
    } else {
      setHelpMenuName('helpmenulist slideDown');
    }
  };

  const toggleNotificationMenu = async (e) => {
    e.stopPropagation();
    if (notificationMenuVisible) {
      setNotificationMenuName('slideUp');
    } else {
      if (helpMenuVisible) setHelpMenuName('helpmenulist slideUp');
      if (mainMenuVisible) setMainMenuName('mainmenulist fadeOut');
      await context.getAllAlertsAsync(1);
      setNotificationMenuName('slideDown');
    }
  };

  const toggleMainMenu = () => {
    if (mainMenuVisible) {
      setMainMenuName('mainmenulist fadeOut');
    } else {
      setMainMenuName('mainmenulist fadeIn');
    }
  };

  const getUserIdAsync = async () => {
    try {
      const response = await getUserId().unwrap();
      setUserIdReponse(response.userId);
      setUserIdVisible(response.status);
      setIsSchoolMethodized(response.isMTPActive);
    } catch (error) {
      console.log(error);
    }
  };

  const updateUserId = () => {
    if (userIdVisible) setUserId('Hide UserId - ' + userIdResponse);
    else setUserId('Show User ID');
  };

  const setUserIdStatusAsync = async () => {
    const option = {
      show: userIdVisible
    };
    try {
      await setUserIdStatus(option).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const handleHelpRequest = () => {
    setHelpFeedbackModalType('help');
    setHelpRequestVisible(true);
  };

  const handleFeedbackRequest = () => {
    setHelpFeedbackModalType('feedback');
    setHelpRequestVisible(true);
  };

  const handlePostFeedbackRedirect  = async () => {
    if (!isClassicSwitchFeedback) {
      setHelpRequestVisible(false);
      return;
    }
    
    try {
      await updateDefaultLoginSiteAsync();
      await handleSiteSwitchLog();
      setRedirectModal(true);
    } catch (err) {
      console.log(err);
    }
  };

  const handleProfileClick = (e) => {
    e.stopPropagation();
    setMainMenuName('mainmenulist fadeOut');
  };

  const handleUserId = async (e) => {
    e.stopPropagation();
    setUserIdVisible(!userIdVisible);
  };

  const getSelectedCenterTitle = () => {
    const selectedCenterItem =
      userCenters.find((center) => center.id === currentCenter) ||
      userCenters.find((center) => center.id === DEFAULT_CENTER_ID) ||
      userCenters[0];
    return (
      <span>
        <span className="fa-layers fa-fw" style={{ marginRight: '15px' }}>
          <FontAwesomeIcon icon={faCircle} color="white" size="2x" />
          <FontAwesomeIcon icon={selectedCenterItem.icon} color="darkred" transform="right-6" />
        </span>
        <span className="navDropdownText text-castleRed">{selectedCenterItem.title}</span>
      </span>
    );
  };

  async function handleSwitchtoClassic(e) {
    e?.preventDefault();
    setChecked(!checked);
    setCenterToRestoreOnCancel(null);
    try {
      var response = await navToClassic({
        reWriteUrl: window.location.href,
        selectedAssignmentId: selectedAssignmentId,
        selectedCenter: getCenterById(currentCenter).name
      });
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      } else {
        setClassicRedirectUrl(response.data.returnUrl);
        setShowConfirmClassicNavModal(true);
        setHelpMenuName('helpmenulist slideUp');
        setMainMenuName('mainmenulist fadeOut');
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleSwitchToClassicConfirm = () => {
    if (navToClassicResults.data.requestFeedback) {
      setShowConfirmClassicNavModal(false);
      setShowFeedbackRequestModal(true);
    } else {
      setShowConfirmClassicNavModal(false);
      setRedirectModal(true);
    }
  };

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      var response = await logout().unwrap();
      if (response.isSuccess) {
        if (response.redirectUrl && response.redirectUrl.length > 0) {
          window.location.href = response.redirectUrl;
          return;
        }
        dispatch(globalLogout());
        navigate('/login');
        setIsLoggingOut(false);
      }
    } catch (ex) {
      console.log(ex);
      dispatch(globalLogout());
      navigate('/login');
      setIsLoggingOut(false);
    }
  };

  const handleToggle = () => {
    setChecked(!checked);
  };

  const handleOutsideClick = () => {
    setOutsideClick(true);
  };

  const handleSiteSwitchLog = async () => {
    try {
      var response = await initialiseSiteSwitchLog();
      let updatedRedirectUrl = classicRedirectUrl + '&logId=' + response.data;
      setClassicRedirectUrl(updatedRedirectUrl);
    } catch (ex) {
      console.log(ex);
    }
  };

  const userCenters = [
    {
      id: CenterTypes.Administrator.id,
      title: 'Administrator Center',
      icon: faUserGear,
      name: CenterTypes.Administrator.name,
      userTypes: [UserTypes.Administrator, UserTypes.SuperAdministrator, UserTypes.Sales, UserTypes.SuperSales, UserTypes.Trainer],
      showNavModel: false
    },
    {
      id: CenterTypes.Teacher.id,
      title: 'Teacher Center',
      icon: faChalkboardUser,
      name: CenterTypes.Teacher.name,
      userTypes: [UserTypes.Administrator, UserTypes.SuperAdministrator, UserTypes.Teacher, UserTypes.HomeTeacher, UserTypes.Sales, UserTypes.SuperSales, UserTypes.Trainer],
      showNavModel: true
    },
    {
      id: CenterTypes.Student.id,
      title: 'Student Center',
      icon: faGraduationCap,
      name: CenterTypes.Student.name,
      userTypes: [UserTypes.Administrator, UserTypes.SuperAdministrator, UserTypes.Teacher, UserTypes.HomeTeacher, UserTypes.Sales, UserTypes.SuperSales, UserTypes.Trainer],
      showNavModel: false
    }
  ];

  const handleClassicCenterSwitch = async (centerItem, previousCenterId) => {
    dispatch(setCurrentCenter({ currentCenter: centerItem.id }));

    if (centerItem.name === CenterTypes.Teacher.name) {
      setCenterToRestoreOnCancel(null);
      return;
    }

    try {
      var response = await navToClassic({
        reWriteUrl: window.location.href,
        selectedAssignmentId: selectedAssignmentId,
        selectedCenter: centerItem.name
      });
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
        dispatch(setCurrentCenter({ currentCenter: previousCenterId }));
      } else {
        setClassicRedirectUrl(response.data.returnUrl);
        if (centerItem.showNavModel) {
          setCenterToRestoreOnCancel(previousCenterId);
          setShowConfirmClassicNavModal(true);
        } else {
          var siteSwitchResponse = await initialiseSiteSwitchLog();
          window.location.href = response.data.returnUrl + '&logId=' + siteSwitchResponse.data;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleMethodize = () => {
    window.open('/methodize', '_blank');
  };

  const handleRookBlueprint = async () => {
    var isRookBlueprintEnabled = await checkBackToBlueprintEnabled().unwrap();
    if (isRookBlueprintEnabled)
      window.open('/rookBlueprint', '_blank');
    else
      window.open('https://www.castlelearning.com/blueprint-landing-page-for-non-blueprint-customer', '_blank');
  };

  const updateDefaultLoginSiteAsync = async () => {
    if (switchableUserTypes.includes(user.UserType))
      await updateDefaultLoginSite({isDefaultClassic : true}).unwrap();
  };

  const showRecentAlertToasts = (alerts) => {
    if (!Array.isArray(alerts)) return;

    alerts.forEach((alert) => {
      toast(<NotificationToast alert={alert} />, {
        icon: false,
        className: 'notification-toast-shell',
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    });
  };

  const viewAllMessageHandler = () => {
    setNotificationMenuName('slideUp');
    navigate('dashboard/view_all_messages');
  };

  const handleMarkAllAsRead = async () => {
    await markAllAsRead().unwrap();
    context?.setAllMessage(prev =>
      prev?.map(message => ({
        ...message,
        viewed: 1
      }))
    );
    context?.setNotViewedAlerts(0);
  };

  return (
    <div className="mainDiv">
      <Navbar>
        <Navbar.Brand className="me-auto my-1">
          <Container fluid className="d-flex align-items-center" style={{ gap: '.5rem' }}>
            <Link to="#" className="menu-bars">
              <div className="barsContainer">
                <FontAwesomeIcon icon={faBarsSort} onClick={showSidebar} className="barElement" />
                <FontAwesomeIcon
                  icon={faBarsSort}
                  onClick={showSidebar}
                  className="barElement bars2"
                />
              </div>
            </Link>
            <Link to="#">
              <img src={CastleLogo} style={{ height: '45px' }} />
            </Link>{' '}
          </Container>
        </Navbar.Brand>
        <Link
          to="#"
          className="d-flex flex-row mx-3 align-items-center"
          style={{ textDecoration: 'none' }}
          onClick={(e)=> handleSwitchtoClassic(e)}>
          <FontAwesomeIcon className="mx-2" color="#F7931E" icon={faSendBackward} />
          <div className="headerText" style={{ color: '#F7931E' }}>
            Back to Classic Version
          </div>
        </Link>
        {/* <Form className="d-flex common-search position-relative">
          <Form.Control
            className="searchBox"
            type="search"
            placeholder="Search here..."
            aria-label="Search"
          />
          <FontAwesomeIcon icon={faSearch} />
        </Form> */}
        <Nav
          className="my-2 my-lg-0 ms-2 me-3"
          style={{ maxHeight: '100px', alignItems: 'center' }}>
          <NavDropdown className="navDropdown me-2" title={getSelectedCenterTitle()} id="selectCenterDropdown">
            {userCenters.filter(item => item.userTypes.includes(user.UserType) && item.id !== currentCenter)
              .map(item => (
                <NavDropdown.Item
                  key={item.title}
                  className="d-flex flex-row align-items-center px-2 text-color"
                  href=""
                  onClick={() => handleClassicCenterSwitch(item, currentCenter)}
                >
                  <FontAwesomeIcon className='fs-5' icon={item.icon} />
                  <span className="fw-normal mx-2">{item.title}</span>
                </NavDropdown.Item>
              ))
            }
          </NavDropdown>
          <div className="stackedIcons ms-2" onClick={(e) => toggleNotificationMenu(e)}>
            <span className="stacked-bg">
              <FontAwesomeIcon icon={faBell} color="#F7931E" />
              {context?.notViewedAlerts > 0 && (
                <span className="notification-badge">
                  {context.notViewedAlerts > 99 ? '99+' : context.notViewedAlerts}
                </span>
              )}
              {notificationMenuVisible && (
                <ClickOutsideDetector onClickOutside={handleOutsideClick}>
                  <div onClick={(e) => e.stopPropagation()}>
                    <Notification
                      allMessage={context?.allMessage}
                      notViewedAlerts={context?.notViewedAlerts}
                      viewAllMessageHandler={viewAllMessageHandler}
                      animationClass={notificationMenuName === 'slideUp'
                        ? 'notification-slide-up'
                        : 'notification-slide-down'}
                      onMarkAllAsRead={handleMarkAllAsRead}
                    />
                  </div>
                </ClickOutsideDetector>
              )}
            </span>
          </div>
          <div className="stackedIcons ms-2" href="" onClick={toggleHelpMenu}>
            <span className="stacked-bg">
              <FontAwesomeIcon icon={faQuestion} color="#F7931E" />
              {helpMenuVisible && (
                <ClickOutsideDetector onClickOutside={handleOutsideClick}>
                  <div className={helpMenuName}>
                    <div className="menulist-aarow"></div>
                    <ul>
                      {helpMenuNav.map((item, index) => {
                        return (
                          <>
                            <li key={index}>
                              {item.id === 'telephone' && (
                                <>
                                  <div className="d-flex align-items-center">
                                    <div className="nav-line"></div>
                                  </div>
                                  <span>
                                    Contact Us<br></br>
                                  </span>
                                </>
                              )}

                              <div
                                className="d-flex align-items-center"
                                onClick={() => item.onClick()}>
                                <div className="icon-div">
                                  <FontAwesomeIcon icon={item.icon} className="icon" />
                                </div>
                                {item.tag === 'a' ? (
                                  <a
                                    href={item.path}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="linkto">
                                    {item.title}
                                  </a>
                                ) : item.tag === 'div' ? (
                                  <div className="linkto">{item.title}</div>
                                ) : null}
                              </div>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </div>
                </ClickOutsideDetector>
              )}
            </span>
          </div>
          <div
            className="stackedIcons ms-2"
            onClick={() => {
              setShowFeedbackRequestModal(false);
              setIsClassicSwitchFeedback(false);
              handleFeedbackRequest();
            }}>
            <span className="stacked-bg">
              <FontAwesomeIcon icon={faMessage} color="#F7931E" />
            </span>
          </div>
          <div className="verticalLine ms-2"></div>
          <div
            className="stackedIcons d-flex flex-row align-items-center ms-2"
            onClick={toggleMainMenu}>
            <span className="stacked-bg stacked-bg-2 me-2">
              {`${user?.FirstName?.slice(0, 1).toUpperCase()}${user?.LastName?.slice(
                0,
                1
              ).toUpperCase()}`}
              {mainMenuVisible && (
                <ClickOutsideDetector onClickOutside={handleOutsideClick}>
                  <div className={mainMenuName}>
                    <div className="menulist-aarow"></div>
                    <ul>
                      {mainMenuNav.map((item, index) => {
                        return (
                          <>
                            {item.id === 'logOut' && (
                              <div key={'line' + index} className="nav-line"></div>
                            )}

                            <li key={index}>
                              <div
                                className="d-flex align-items-center"
                                onClick={(e) => item.onClick(e)}>
                                <div className="icon-div">
                                  <FontAwesomeIcon icon={item.icon} className="icon" />
                                </div>
                                {item.tag === 'a' ? (
                                  <a target={item.path} rel="noreferrer" className="linkto">
                                    {item.title}
                                  </a>
                                ) : item.tag === 'link' ? (
                                  <Link
                                    to={item.path}
                                    className="linkto"
                                    style={
                                      item.comingSoon
                                        ? { pointerEvents: 'none', cursor: 'none' }
                                        : null
                                    }>
                                    {item.title}{' '}
                                    {item.comingSoon && (
                                      <>
                                        (<span style={{ color: '#F7931E' }}>Coming Soon!</span>)
                                      </>
                                    )}
                                  </Link>
                                ) : (
                                  <div className="linkto">{item.title}</div>
                                )}

                                {item.id === 'classicSwitch' && (
                                  <div key={'toogle' + index} className="d-flex align-items-center">
                                    <Toggle
                                      id="flexSwitchCheckChecked"
                                      checked={checked}
                                      onChange={handleToggle}
                                      icons={false}
                                      className="custom-toggle"
                                    />
                                  </div>
                                )}
                              </div>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </div>
                </ClickOutsideDetector>
              )}
            </span>

            <span className="headerText text-color">{`${user?.FirstName} ${user?.LastName}`}</span>
          </div>
        </Nav>
      </Navbar>
      <nav id="sidebar">
        <div className="sideBarContainer">
          <nav className={sidebar ? 'nav-menu open' : 'nav-menu'}>
            <ul className="nav-menu-items">
              {SidebarData.map((item, index) => {
                return (
                  <li key={index}>
                    <OverlayTrigger
                      key={`${item.title}-${index}`}
                      placement="right"
                      overlay={
                        <Tooltip className="custom-tooltip">{item.title}</Tooltip>
                      }>
                      {
                        item.title === 'Methodize' ? (
                          <div className={(!isSchoolMethodized ? 'd-none ' : '') + item.class} onClick={() => handleMethodize()}>
                            <div className="nav-item-content cursor-pointer">
                              {item.icon}
                              <span className={sidebar ? '' : 'hidden'}>{item.title}</span>
                            </div>
                          </div>
                        ) : (
                          item.title === 'Rook Blueprint' ? (
                            <div className={item.class} onClick={() => handleRookBlueprint()}>
                              <div className="nav-item-content cursor-pointer">
                                {item.icon}
                                <span className={sidebar ? '' : 'hidden'}>{item.title}</span>
                              </div>
                            </div>
                          ) : (
                            <NavLink
                              to={
                                item.title !== 'Methodize'
                                  ? item.path
                                  : ''
                              }
                              className={item.class}
                              style={({ isActive }) => ({
                                color: isActive ? '#872926' : ''
                              })}>
                              <div className="nav-item-content">
                                {item.icon}
                                <span className={sidebar ? '' : 'hidden'}>{item.title}</span>
                              </div>
                            </NavLink>
                          )
                        )}
                    </OverlayTrigger>
                  </li>
                );
              })}
              <li style={{ marginTop: 'auto' }} onClick={handleSwitchtoClassic}>
                <OverlayTrigger
                  key={'backtoclassic'}
                  placement="right"
                  overlay={
                    <Tooltip className="custom-tooltip">{'Back to Classic Version'}</Tooltip>
                  }>
                  <div id="rtnClassic" className="nav-text" style={{ cursor: 'pointer' }}>
                    <div className="nav-item-content">
                      <div className="stackedIcons fa-layers fa-fw me-2" href="">
                        <FontAwesomeIcon
                          icon={faCircle}
                          color="#F7931E"
                          transform="grow-10"
                          fixedWidth
                        />
                        <FontAwesomeIcon
                          icon={faSendBackward}
                          transform="shrink-2"
                          color="#FFFFFF"
                        />
                      </div>
                      <span className={sidebar ? '' : 'hidden'}>Back to Classic Version</span>
                    </div>
                  </div>
                </OverlayTrigger>
              </li>
            </ul>
          </nav>
        </div>
      </nav>
      <HelpRequest
        modalData={helpRequestVisible}
        setModalData={setHelpRequestVisible}
        modalSubmissionType={helpFeedbackModalType}
        setFeedbackSent={setFeedbackSent}
        onSubmitSuccess={handlePostFeedbackRedirect}
        onRequestClose={handlePostFeedbackRedirect}
      />

      <Modal
        contentWidth="30%"
        isOpen={showConfirmClassicNavModal}
        titleName={'Go to Classic Castle'}
        onClose={() => {
          setShowConfirmClassicNavModal(false);
          setClassicRedirectUrl(null);
          setMainMenuName('mainmenulist fadeOut');
          setHelpMenuName('helpmenulist slideUp');
          setChecked(false);
          if (centerToRestoreOnCancel !== null) {
            dispatch(setCurrentCenter({ currentCenter: centerToRestoreOnCancel }));
            setCenterToRestoreOnCancel(null);
          }
        }}>
        <div className='text-center fw-semibold'>Switch back to Classic Castle for now?</div>
        <div className="mt-2">
            We are moving all accounts to the new look in the future. Until then, you can switch
            back to the old look.
        </div>
        <div className="d-flex flex-row justify-content-end w-100 mt-4">
          <Button
            variant="castleGray"
            onClick={() => {
              setShowConfirmClassicNavModal(false);
              setClassicRedirectUrl(null);
              setMainMenuName('mainmenulist fadeOut');
              setHelpMenuName('helpmenulist slideUp');
              setChecked(false);
              if (centerToRestoreOnCancel !== null) {
                dispatch(setCurrentCenter({ currentCenter: centerToRestoreOnCancel }));
                setCenterToRestoreOnCancel(null);
              }
            }}
            className="me-2 btn-width">
              Cancel
          </Button>
          <Button
            variant="castleOrange"
            onClick={() => {
              setIsClassicSwitchFeedback(true);
              handleSwitchToClassicConfirm();
              setMainMenuName('mainmenulist fadeOut');
              setHelpMenuName('helpmenulist slideUp');
              setCenterToRestoreOnCancel(null);
            }}
            className="btn-width">
              Switch back
          </Button>
        </div>
      </Modal>

      <Modal
        contentWidth="45%"
        isOpen={showFeedbackRequestModal}
        titleName={'Go to Classic Castle'}
        onClose={() => {
          setShowFeedbackRequestModal(false);
          setClassicRedirectUrl(null);
          setChecked(false);
          setFeedbackSent(false);
          setMainMenuName('mainmenulist fadeOut');
        }}>
        <div className="d-flex flex-column align-items-center">
          <div>
            Thank you for trying out the new Castle. Would you mind giving some feedback before you
            go?
          </div>

          <div className="d-flex flex-row justify-content-end w-100 mt-4">
            <Button
              variant="castleWhite"
              onClick={async() => {
                await updateDefaultLoginSiteAsync();
                await handleSiteSwitchLog();
                setShowFeedbackRequestModal(false);
                setRedirectModal(true);
              }}
              className="me-2 btn-width">
              No thanks
            </Button>
            <Button
              variant="castleRed"
              onClick={async() => {
                setShowFeedbackRequestModal(false);
                setChecked(false);
                handleFeedbackRequest();
              }}>
              Yes, I would like to give feedback
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        contentWidth="40%"
        isOpen={showLogoutModal}
        titleName={'Logout'}
        onClose={() => setShowLogoutModal(false)}>
        <div className="d-flex flex-column align-items-center">
          <div
            className="mb-3"
            style={{
              backgroundImage: `url(${logoutImg})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100%',
              height: '130px',
              width: '199px'
            }}></div>
          <div style={{ fontWeight: '500', fontSize: '1em' }} className="mb-3 text-color">
            Are you sure you want to logout of your session?
          </div>
          <div className="d-flex flex-row w-50 justify-content-evenly">
            <Button
              variant="castleWhite"
              style={{ width: '40%' }}
              onClick={() => setShowLogoutModal(false)}
              disabled={isLoggingOut}>
              No
            </Button>
            <Button
              variant="castleRed"
              style={{ width: '40%' }}
              onClick={(e) => handleLogout(e)}
              disabled={isLoggingOut}>
              {isLoggingOut ? 'Logging out...' : 'Yes'}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        contentWidth="40%"
        isOpen={redirectModal}
        titleName={'Returning to Classic Castle'}
        onClose={() => {
          setClassicRedirectUrl(null);
          setRedirectModal(false);
          setChecked(false);
        }}
        hideClosingX={true}
        disableBackdropClose={true}>
        <div className="d-flex flex-column align-items-center">
          {feedbackSent && <div className="mb-3">Thank you for your feedback!</div>}
          <div>You will now be redirected to Classic Castle...</div>
        </div>
      </Modal>
    </div>
  );
}

Navigation.propTypes = {
  details: PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
    description: PropTypes.string
  }),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};